document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var cartToggles = document.querySelectorAll('[data-cart-toggle]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  }
  cartToggles.forEach(function (btn) { btn.addEventListener('click', openCart); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  /* ---------- Mobile menu / search toggles (basic no-op targets for future nav drawer) ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var searchToggle = document.querySelector('[data-search-toggle]');
  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      document.querySelector('.header-nav').classList.toggle('mobile-open');
    });
  }
  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'search';
    });
  }

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main-img]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var track = gallery.querySelector('.product-thumbs-track');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) mainImg.src = thumb.getAttribute('data-full');
      });
    });

    var prev = gallery.querySelector('[data-thumb-prev]');
    var next = gallery.querySelector('[data-thumb-next]');
    if (prev && track) prev.addEventListener('click', function () { track.scrollBy({ left: -90, behavior: 'smooth' }); });
    if (next && track) next.addEventListener('click', function () { track.scrollBy({ left: 90, behavior: 'smooth' }); });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var input = sel.querySelector('[data-qty-input]');
    var minus = sel.querySelector('[data-qty-minus]');
    var plus = sel.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- Purchase option (one-time vs subscribe) ---------- */
  document.querySelectorAll('[data-purchase-option]').forEach(function (option) {
    option.addEventListener('click', function () {
      var group = option.closest('.product-form');
      if (!group) return;
      group.querySelectorAll('[data-purchase-option]').forEach(function (o) { o.classList.remove('selected'); });
      option.classList.add('selected');
      var radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      var select = group.querySelector('[data-selling-plan-select]');
      if (select) select.disabled = !(radio && radio.value === 'subscribe');
    });
  });

  /* ---------- Product info tabs ---------- */
  document.querySelectorAll('[data-tab-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var nav = trigger.closest('.tabs-nav');
      var wrapper = trigger.closest('.product-tabs');
      nav.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
      trigger.classList.add('active');
      wrapper.querySelectorAll('.tab-panel').forEach(function (p) { p.classList.remove('active'); });
      var target = wrapper.querySelector('#' + trigger.getAttribute('data-tab-trigger'));
      if (target) target.classList.add('active');
    });
  });

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll('form[action^="/cart/add"], form.product-form').forEach(function (form) {
    var lastSubmitter = null;
    form.addEventListener('click', function (e) {
      if (e.target.closest('button[type="submit"]')) lastSubmitter = e.target.closest('button[type="submit"]');
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var buyNow = lastSubmitter && lastSubmitter.hasAttribute('data-buy-now');
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (buyNow) {
            window.location.href = '/checkout';
          } else {
            refreshCartCount();
            openCart();
          }
        })
        .catch(function () { form.submit(); });
    });
  });

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  /* ---------- Product recommendations (fetched per Shopify's recommendations endpoint) ---------- */
  document.querySelectorAll('[data-recommendations-section]').forEach(function (section) {
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-recommendations-grid]');
        var currentGrid = section.querySelector('[data-recommendations-grid]');
        if (newGrid && currentGrid && newGrid.innerHTML.trim() !== '') {
          currentGrid.innerHTML = newGrid.innerHTML;
        }
      });
  });

});
